import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AppRouter } from './AppRouter';
import './index.css';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-3087" data-mp="26ac1gye10kvh">
    <HelmetProvider data-id="element-3088" data-mp="26alqainc4lzl">
      <ErrorBoundary data-id="element-3089" data-mp="266xwdidz9xkc">
        <AppRouter data-id="element-3090" data-mp="2ab5pdrrgxzod" />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>);
// Signal to pre-renderers that the page is fully rendered
// Uses setTimeout(0) for maximum compatibility — signals after the next tick
// This is safer than requestIdleCallback which can delay in some environments
setTimeout(() => {
  ;
  (window as any).prerenderReady = true;
  document.dispatchEvent(new Event('render-event'));
}, 0);